import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gd-header-wrap" }
const _hoisted_2 = {
  class: "bar bar--header",
  role: "banner"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "gd-market-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "",
    alt: "Local market logo",
    height: "60"
  })
], -1)
const _hoisted_4 = { class: "bar__center" }
const _hoisted_5 = { class: "headertextalign" }
const _hoisted_6 = { class: "headertextalign" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getTranslatedValue("labeltext.dataProtectionAct")), 1)
        ]),
        _createElementVNode("h2", null, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getTranslatedValue("labeltext.dataSAR")), 1)
        ])
      ])
    ])
  ]))
}